module.exports = __webpack_public_path__ + "media/preview/recruitment@4x-a4ba156d.png";